import { render, staticRenderFns } from "./Nested.vue?vue&type=template&id=c83b463a&"
import script from "./Nested.vue?vue&type=script&lang=js&"
export * from "./Nested.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports